"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlResolver = void 0;

var _qs = _interopRequireDefault(require("qs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Export `UrlResolver`.
 */
var UrlResolver = /*#__PURE__*/function () {
  /**
   * Domain.
   */

  /**
   * Protocol.
   */

  /**
   * Constructor.
   */
  function UrlResolver(options) {
    _classCallCheck(this, UrlResolver);

    this.domain = options.domain;
    this.protocol = options.protocol;
  }
  /**
   * Resolve.
   */


  _createClass(UrlResolver, [{
    key: "resolve",
    value: function resolve(payspaceSlug, path, search) {
      var url = new URL(path, "".concat(this.protocol, "//").concat(payspaceSlug, ".").concat(this.domain));

      if (search) {
        url.search = _qs["default"].stringify(search);
      }

      return url.toString();
    }
  }]);

  return UrlResolver;
}();

exports.UrlResolver = UrlResolver;